export default __webpack_public_path__ + "static/media/userprofile.a7d70cdd.svg";